module.exports = "/images/dm.svg?a32c26463b5f64745ff66644eac9734a";